import React from 'react';
import { Button, Modal, Text } from '@companycam/slab-web';
import styled from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { LD_REVIEWS_BETA_FLAG } from 'constants/featureFlags';
import steven from 'helpers/steven';
import { translate } from 'javascripts/translations/i18n';
import useCompanyFeatureOptIn from '../hooks/useCompanyFeatureOptIn';
import { useModal } from 'components/shared/hooks';
import { useGetPublicProfiles } from 'data/v3/publicProfiles';
import ReviewProfileManager from 'components/reviews/ReviewProfileManager';
import { BetaBadge } from 'components/shared/Badge';

const ContentContainerDiv = styled.div`
  padding: var(--cc_size_spacing_m);
`;

const StyledReviewProfileManager = styled(ReviewProfileManager)`
  margin-bottom: var(--cc_size_spacing_m);
  margin-top: var(--cc_size_spacing_l);
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_s);
`;

const cancelText = translate('common.cancel');
const doneText = translate('common.done');
const viewReviewsHubText = translate('project.reviews.viewReviewsHub');
const optInText = translate('project.reviews.optIn');
const optInSuccessTitleText = translate('project.reviews.requestReview');

const RequestReviewFalseDoorModal = () => {
  const flags = useFlags();
  const isReviewsBetaJoined = flags[LD_REVIEWS_BETA_FLAG];
  const { hideModal } = useModal();
  const { data: publicProfileResponse, isLoading } = useGetPublicProfiles();
  const publicProfile = publicProfileResponse?.data[0] || null;

  const { optInToFeature, loading } = useCompanyFeatureOptIn();

  const handleOptIn = async () => {
    optInToFeature('reviews');
    steven.elementClicked({
      id: 'request_review_modal_opt_in',
      content: 'Get Early Access',
      action: 'request_review_modal_opt_in_clicked',
      type: 'button',
    });
  };

  const handleViewReviewsHub = () => {
    steven.elementClicked({
      id: 'request_review_modal_view_reviews_hub',
      content: 'View Reviews Hub',
      action: 'request_review_modal_view_reviews_hub_clicked',
      type: 'button',
    });
    window.Turbo.visit('/reviews');
  };

  const handlePlaceIdAdd = () => {
    const projectId = window.location.pathname.split('/')[2];
    setTimeout(() => {
      window.Turbo.visit(`/projects/${projectId}/review-requests/new`);
    }, 1000);
  };

  return (
    <Modal
      title={null}
      headerComponent={null}
      size="small"
      isOpen
      onClose={hideModal}
      footerActions={
        isReviewsBetaJoined ? (
          <>
            <Button
              color="secondary"
              design="outline"
              onClick={handleViewReviewsHub}
            >
              {viewReviewsHubText}
            </Button>
            <Button color="primary" onClick={hideModal}>
              {doneText}
            </Button>
          </>
        ) : (
          <>
            <Button onClick={hideModal}>{cancelText}</Button>
            <Button
              color="primary"
              onClick={handleOptIn}
              disabled={loading}
              loading={loading}
            >
              {optInText}
            </Button>
          </>
        )
      }
    >
      <ContentContainerDiv>
        <div>
          <TitleContainer>
            <Text as="h2" size="xl">
              {optInSuccessTitleText}
            </Text>
            <BetaBadge />
          </TitleContainer>
          {publicProfile || isLoading ? null : (
            <div>
              <StyledReviewProfileManager onSuccess={handlePlaceIdAdd} />
            </div>
          )}
        </div>
      </ContentContainerDiv>
    </Modal>
  );
};

export default RequestReviewFalseDoorModal;
